/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */
import ShowcaseNotifications from './showcase-notifications';

export default ShowcaseNotifications;


// WEBPACK FOOTER //
// ./src/containers/ShowcaseNotifications/index.js